<template>
  <div>
    <v-row>
      <v-col cols="12" md="6" lg="4">
        <v-card class="elevation-12">
          <v-card-title>
            <v-btn color="primary" text :to="{name: 'monitoring-mails'}">{{ $t('monitoringDashboard.cards.mails') }}</v-btn>
          </v-card-title>
        </v-card>
      </v-col>

      <v-col cols="12" md="6" lg="4">
        <v-card class="elevation-12">
          <v-card-title>
            <v-btn color="primary" text :to="{name: 'monitoring-statistics-dashboard-page'}">{{ $t('monitoringDashboard.cards.statistics') }}</v-btn>
          </v-card-title>
        </v-card>
      </v-col>


      <v-col cols="12" md="6" lg="12">
        <v-card class="elevation-12">
          <v-card-title>
            <v-btn color="primary" text :to="{name: 'monitoring-contracts-statistics'}">{{ $t('adminStatisticsDashboard.cards.byContracts') }}</v-btn>
          </v-card-title>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import {LAYOUT_TITLE_CHANGED} from "@/store/modules/layout/actions";

export default {
  name: "MonitoringDashboardPage",
  computed: { },
  created() {
    this.$store.dispatch(LAYOUT_TITLE_CHANGED, this.$t('monitoringDashboard.pageTitle'))
  }
}
</script>

<style scoped>

</style>